import { useState } from 'react';
import { Bot, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export default function PublicLandingAiBubble({ endpoint, intro = 'Hola, soy la IA del portal. ¿En qué te ayudo?', placeholder = 'Pregunta por propiedades, precios o disponibilidad...' }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([{ role: 'assistant', content: intro }]);
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!message.trim()) return;
    const text = message.trim();
    setMessages(prev => [...prev, { role: 'user', content: text }]);
    setMessage('');
    setSending(true);
    try {
      const r = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ message: text }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || 'Error');
      setMessages(prev => [...prev, { role: 'assistant', content: data.reply }]);
    } catch {
      setMessages(prev => [...prev, { role: 'assistant', content: 'No pude responder en este momento. Déjanos tus datos y un asesor dará seguimiento.' }]);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} className="fixed bottom-6 right-24 z-50 w-14 h-14 rounded-full bg-primary text-black shadow-lg flex items-center justify-center" data-testid="public-landing-ai-bubble">
        <Bot className="w-6 h-6" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0a0c12] border-white/10 max-w-md" data-testid="public-landing-ai-dialog">
          <DialogHeader><DialogTitle className="text-white">Asistente IA del portal</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="max-h-80 overflow-y-auto space-y-2 pr-1">
              {messages.map((item, idx) => (
                <div key={idx} className={`rounded-xl px-3 py-2 text-xs ${item.role === 'assistant' ? 'bg-white/5 text-white/80' : 'bg-primary/15 text-primary ml-8'}`}>{item.content}</div>
              ))}
            </div>
            <div className="flex gap-2">
              <Input value={message} onChange={e => setMessage(e.target.value)} placeholder={placeholder} className="bg-black/20 border-white/10" data-testid="public-landing-ai-input" />
              <Button onClick={send} disabled={sending} data-testid="public-landing-ai-send">{sending ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Enviar'}</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}